module.exports = __webpack_public_path__ + "static/media/home-compress.24756870.mp4";